export const LAYER_IMGS = {
	DEFAULT: "/img/mapset/foto-small.png",
	OPHOTO: "/img/mapset/letecka-small.png",
	WINTER: "/img/mapset/zimni-small.png",
};

export const DROPS = {
	BIG_RED: {
		id: 1,
		src: "/wasm/drop/big-red.png",
	},
	MEDIUM_RED: {
		id: 2,
		src: "/wasm/drop/medium-red.png",
	},
	SMALL_RED: {
		id: 3,
		src: "/wasm/drop/small-red.png",
	},
	MEDIUM_RED_ICON: {
		id: 4,
		src: "/wasm/drop/medium-red.png",
	},
	LARGE_RED_ICON: {
		id: 5,
		src: "/wasm/drop/big-red.png",
	},
	UNIVERSAL: {
		id: 6,
		src: "/wasm/drop/universal.png",
	},
	ROUTE_START: {
		id: 7,
		src: "/wasm/drop/route-start.png",
	},
	ROUTE_END: {
		id: 8,
		src: "/wasm/drop/route-end.png",
	},
	DISTANCEMETER: {
		id: 9,
		src: "/wasm/drop/distancemeter.png",
	},
};
